import React from 'react';
import './AlertHeadline.css';

const AlertHeadline = (props) => {
   return (
     <div className="AlertHeadline--container">
       {/* <span className="AlertHeadline--text">Real Time Touch is the "Missing Link" of Telemedicine</span> - read below for latest updates! */}
       {/* <span className="AlertHeadline--text"><a href="http://www.realtimetouch.com/updates/#Craig-Linden-ATA18" style={{color:'red'}}><b>Real Time Touch inventor Craig Linden was at the ATA18 telemedicine conference!</b></a></span> - <a href="https://www.realtimetouch.com/contact/" style={{color:'darkblue'}}>Contact Craig</a>! */}

      {/* <span className="AlertHeadline--text"><b><span style={{color:'red'}}>NEW!</span> <a href="http://www.realtimetouch.com/updates/#Craig-Linden-on-Amazon-PillPack" style={{color:'black'}}>Real Time Touch Founder Craig Linden's Analysis of Amazon's plans to purchase PillPack an Online Pharmacy</a></b></span> - <a href="http://www.realtimetouch.com/updates/#Craig-Linden-on-Amazon-PillPack" style={{color:'darkblue'}}>Read More...</a> */}

      {/* <span className="AlertHeadline--text"><b><span style={{color:'red'}}>NEW!</span> <img src="https://www.realtimetouch.com/images/remoterx/PDF_32.png" style={{marginRight: 4}} /><a href="https://www.realtimetouch.com/remoterx" style={{color:'black'}}>PDF Brochure - World's First Remote Caregiver-controlled Rx Home Dispenser</a></b></span> - <a href="https://www.realtimetouch.com/remoterx" style={{color:'darkblue'}}>More...</a> */}

      <span className="AlertHeadline--text"><b><span style={{color:'red'}}> TOP 10 INNOVATOR</span> - <a href="/updates/#RTT-Mirror-Review" style={{color:'black'}}>RTT inventor Craig Linden declared a Top 10 Leader in Transforming Healthcare by Mirror Review magazine</a></b></span> - <a href="/updates/#RTT-Mirror-Review" style={{color:'darkblue'}}>More...</a>

      
      

     {/* <Placeholder {...props} />   */}
     </div>
   )
 }

 export default AlertHeadline;


// WEBPACK FOOTER //
// ./src/common/AlertHeadline/AlertHeadline.js